import { useState, useMemo } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Button } from './ui/button';
import { LayoutDashboard, FileText, Users, ScanLine, BarChart3, ShieldCheck, Menu, X } from 'lucide-react';
import { DesktopNav, MobileNav } from './layout/Nav';
import { UserMenu, StatusBadge } from './layout/UserMenu';

const BASE_NAV = [
  { path: '/dashboard', label: 'Dashboard', icon: LayoutDashboard },
  { path: '/students', label: 'Élèves', icon: Users },
  { path: '/quizzes', label: 'QCM', icon: FileText },
  { path: '/scan', label: 'Scanner', icon: ScanLine },
  { path: '/results', label: 'Résultats', icon: BarChart3 },
];

export default function Layout({ children }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [mobileOpen, setMobileOpen] = useState(false);

  const navItems = useMemo(() => {
    const items = [...BASE_NAV];
    if (user?.is_admin) {
      items.push({ path: '/admin', label: 'Admin', icon: ShieldCheck });
    }
    return items;
  }, [user?.is_admin]);

  const handleLogout = async () => {
    await logout();
    navigate('/');
  };

  return (
    <div className="min-h-screen bg-background">
      <header className="sticky top-0 z-40 bg-background/80 backdrop-blur-sm border-b border-border" data-testid="main-header">
        <div className="max-w-6xl mx-auto flex items-center justify-between px-4 h-12">
          <div className="flex items-center gap-4">
            <Link to="/dashboard" className="flex items-center gap-1 font-black text-base tracking-tight" data-testid="logo-link">
              <span className="text-primary">QCM</span><span>AntiTriche</span>
            </Link>
            <DesktopNav items={navItems} />
          </div>
          <div className="flex items-center gap-2">
            <StatusBadge user={user} />
            <UserMenu user={user} onLogout={handleLogout} />
            <Button variant="ghost" size="sm" className="md:hidden" onClick={() => setMobileOpen(!mobileOpen)} data-testid="mobile-menu-toggle">
              {mobileOpen ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
            </Button>
          </div>
        </div>
        {mobileOpen && <MobileNav items={navItems} onClose={() => setMobileOpen(false)} />}
      </header>
      <main className="max-w-6xl mx-auto px-4 py-6" data-testid="main-content">
        {children}
      </main>
    </div>
  );
}
